export default __webpack_public_path__ + "static/25037-fa7337a510e8c2127b697226f7d44f33.jpg";